import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import Toggle from 'components/Toggle'
import LANGUAGES from 'const/languages'

export class UserSettingsGeneral extends React.Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,

    requestChangeUserSettings: PropTypes.func.isRequired
  }

  handleMyBoardTileChange = (value) => {
    let tiles = ['Notifications']
    if (value) {
      tiles = ['Notifications', 'MyBoard']
    }

    this.props.requestChangeUserSettings({
      tiles
    })
  }

  handleLangChange = (event) => {
    this.props.requestChangeUserSettings({
      lang: event.target.value
    })
  }

  render () {
    const {
      config,
      settings
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='GENERAL' />}
      >
        <ViewBody>
          <FormGroup controlId='lang'>
            <ControlLabel><FormattedMessage id='LANGUAGE' /></ControlLabel>
            <FormControl
              componentClass='select'
              value={settings.lang}
              onChange={this.handleLangChange}
            >
              {LANGUAGES.map(lang =>
                <FormattedMessage key={lang} id={'LANGUAGE_' + lang}>
                  {(formattedMessage) => (
                    <option key={lang} value={lang}>{formattedMessage}</option>
                  )}
                </FormattedMessage>
              )}
            </FormControl>
          </FormGroup>
          {config.myBoard &&
            <FormGroup controlId='myBoardTile'>
              <ControlLabel><FormattedMessage id='USER_SETTINGS_MYBOARD_TILE' /></ControlLabel>
              <div>
                <Toggle
                  checked={settings.tiles[1] === 'MyBoard'}
                  onChange={this.handleMyBoardTileChange}
                />
              </div>
            </FormGroup>
          }
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default UserSettingsGeneral
